
import React from 'react';
import { View } from './Base';
import { getSrc, parseSrc, parseFile } from './Explorer';
import {EmptySlim} from 'codeArt/components/Base';

export class Html extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      html: this.process(props.html)
    }
  }

  getConfig(){
    let {size} = this.props;
    switch(size){
      case "xs":
        return {
          textClassName:"c-text-s1 mb-0"
        };
      case "sm":
        return {
          textClassName:"c-text-s1d5 mb-0"
        };
      case "md":
        return {
          textClassName:"c-text-s2 mb-0"
        };
    }
    return {
      textClassName:"c-text-s2 mb-0"
    };
  }

  componentWillReceiveProps(nextProps) {
    let oldHtml = this.props.html;
    let newHtml = nextProps.html;
    if (oldHtml !== newHtml) {
      this.setState({
        html: this.process(newHtml)
      });
    }
  }

  process(html) {
    if (!html) return '';
    let temp = document.createElement("div");
    temp.innerHTML = html;
    let images = temp.getElementsByTagName("img");
    for (let i = 0; i < images.length; i++) {
      let g = images[i];
      if (g.getAttribute("data-upload")) {
        let src = g.getAttribute("src");
        let data = parseSrc(src);
        src = getSrc(data, data.Width, data.Height);
        g.setAttribute("src", src);
      }
    }
    
    let as = temp.getElementsByTagName("a");
    for (let i = 0; i < as.length; i++) {
      let g = as[i];
      let href = g.getAttribute("href");
      if (href) {
        let data = parseFile(href);
        if (data) g.setAttribute("href", `javascript:download(${JSON.stringify(data)});`);
      }

      let command = g.getAttribute("data-ca-command");
      if(command){
        g.setAttribute("href", "javascript:void(0);");
        g.setAttribute("target", "_self");
        g.setAttribute("onclick", `${command}(this);`);
      }
    }

    return temp.innerHTML;
  }

  empty(t){
    let { empty } = this.props;
    return (!t && empty)?<EmptySlim gap={2} className="empty c-text-s2" label={empty} />:null;
  }

  renderCode() {
    let { code, className, style, textClassName } = this.props;
    let empty = this.empty(code);
    if(empty) return empty;
    let temp = code.split('\n');
    let config = this.getConfig();
    return (
      <div className={`c-html ${className}`} style={style}>
        {
          temp.map((item, i) => {
            return (
              <p key={i} className={`c-wrap ${textClassName} ${config.textClassName}`}>
                {item}
              </p>
            )
          })
        }
      </div>);
  }

  renderHtml() {
    let { className, style,textClassName } = this.props;
    let { html } = this.state;
    let empty = this.empty(html);
    if(empty) return empty;
    //root里不能有d-flex flex-column的样式，因为内部元素设置了固定高度，不会撑开root
    let config = this.getConfig();
    return (
      <div ref="root" className={`c-html ${config.textClassName} ${textClassName} ${className}`} style={style} dangerouslySetInnerHTML={{ __html: html }}>
      </div>
    );
  }

  render() {
    let { code } = this.props;
    return (
      code ? this.renderCode() : this.renderHtml()
    );
  }
}

Html.defaultProps = {
  size:"xs",
  textClassName:'',
  paragraphSpace: 0,
  className: ''
}